import type { Agreement } from '~/types';
import { BaseModel } from '~/models/base-model';
import * as v from 'valibot';
import { fieldModelErrors as fErr } from '~/constants';

export class AgreementModel extends BaseModel<Agreement> {}

export function getAgreementFormModel(
    nameRequired: boolean,
    paymentRequired: boolean
) {
    const nameObj = v.pipe(
        v.string(fErr.name),
        v.minLength(1, fErr.name)
    );

    return v.object({
        name: nameRequired ? nameObj : v.optional(v.nullish(nameObj)),
        paymentMethodId: paymentRequired ?
            v.string(fErr.paymentMethod) :
            v.optional(v.nullish(v.string()))
    });
}
